import { getJobsQueryKey } from "@react/domains/jobs";
import {
  cursorPaginatedQueryOptions,
  queryOptions,
} from "@react/foundation/query";

import { useAuth } from "../contexts/auth/useAuth.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useQueries() {
  const { api } = useAuth();

  return {
    getGenerationsQueryOptions: cursorPaginatedQueryOptions({
      queryFn: api.generation.getGenerations,
      queryKey: {
        group: () => ["api.generation.getGenerations"],
        variant: data => [data.order],
      },
    }),
    getGithubConnectionsQueryOptions: queryOptions({
      queryFn: api.github.getAllGithubConnections,
      queryKey: { group: () => ["api.github.getAllGithubConnections"] },
    }),
    getJobsQueryOptions: queryOptions({
      queryFn: api.bus.getJobs,
      queryKey: {
        group: getJobsQueryKey,
        variant: data => [data.order, data.cursor, data.limit],
      },
    }),
    getMediaTaxonomiesQueryOptions: queryOptions({
      queryFn: api.media.getMyTaxonomies,
      queryKey: { group: () => ["api.media.getMyTaxonomies"] },
    }),
    getMemoriesQueryOptions: cursorPaginatedQueryOptions({
      queryFn: api.memory.getMemories,
      queryKey: {
        group: data => ["api.memory.getMemories", data.projectId],
        variant: data => [data.order],
      },
    }),
    getMemoryGithubCommentsQueryOptions: cursorPaginatedQueryOptions({
      queryFn: api.memory.getGithubComments,
      queryKey: {
        group: data => ["api.memory.getGithubComments", data.githubRepoId],
        variant: data => [data.order],
      },
    }),
    getMemoryProjectQueryOptions: queryOptions({
      queryFn: api.memory.getProject,
      queryKey: { group: data => ["api.memory.getProject", data.id] },
    }),
    getMemoryProjectsQueryOptions: queryOptions({
      queryFn: api.memory.getAllProjects,
      queryKey: { group: () => ["api.memory.getAllProjects"] },
    }),
    getOAuthRequestQueryOptions: queryOptions({
      queryFn: api.oauth.getRequest,
      queryKey: { group: data => ["api.oauth.getRequest", data.id] },
    }),
    getTaxonomyFolderTreeQueryOptions: queryOptions({
      queryFn: api.taxonomy.getFolderTree,
      queryKey: {
        group: data => ["api.taxonomy.getFolderTree", data.taxonomyId],
      },
    }),
  };
}
